// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  hmr: false,
  apiUrl: 'https://localhost:44377',
  apiVersion: '1',
  apiUrlForIdentity: 'https://staging.api.identity.ten.sidcoop.org',
  apiVersionForIdentity: '1',
  // Previous Identity host, kept alongside the .NET 10 one above
  // apiUrlForIdentityLegacy: 'https://staging.api.identity.sidcoop.org',
  // apiVersionForIdentityLegacy: '1',
  apiUrlForReportGenerator: 'https://staging.api.dw.reportgenerator.sidc.coop',
  apiVersionForReportGenerator: '1',
  apiUrlForReportServer: 'https://staging.api.reports.sidcoop.org',
  apiVersionForReportServer: '1',

  apiUrlForDWInventory: 'https://staging.api.dw.inventory.sidc.coop',
  apiVersionForDWInventory: '1',

  apiUrlForPayroll: 'https://staging.api.payroll.sidcoop.org',
  apiVersionForPayroll: '1',

  projectCodeForReportServer: 'SC',

  // Application code in the Identity token response that grants access to this app
  applicationCode: 'HRIS'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
